export const getDefaultsByKeys = (defaults: Record<string, any>, keys: string[]): Record<string, any> => {
    const keySet = new Set(keys);

    return Object.fromEntries(Object.entries(defaults).filter(([key]) => keySet.has(key)));
};
